import * as React from "react";
import { connect } from "react-redux";
import * as Flex from "@twilio/flex-ui";
import uhaulStore from "../CustomRedux/UhaulStore";
import { updateCannedMessages } from "./Actions/CannedResponsesActions";
import ExceptionLogger from "../ExceptionHelper";
import { Box, Text, UnorderedList, ListItem, Button } from "@twilio/flex-ui/node_modules/@twilio-paste/core"
import GetLiveChatHeader from "../LiveChatHeaderHelper";

export class CannedMessages extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            cannedMessages: [],
            attributes: null,
            newProps: { ...this.props }
        };
    }

    state = this.getCurrentStateFromStore()

    getCurrentStateFromStore() {
        return {
            config: uhaulStore.getState().FlexReducer.config,
            cannedMessages: uhaulStore.getState().UhaulReducer.cannedMessages,
            taskContexts: uhaulStore.getState().UhaulReducer.currentTaskContext
        }
    }

    updateStateFromStore = () => {
        const currentState = this.getCurrentStateFromStore();

        if (this.state !== currentState) {
            this.setState(currentState);
        }
    }

    sendThisMessage = (theMessage) => {
        const taskContexts = uhaulStore.getState().UhaulReducer.currentTaskContext;
        if (!taskContexts || !taskContexts._task || !taskContexts._task.attributes) {
            return;
        }
        Flex.Actions.invokeAction("SetInputText", {
            conversationSid: taskContexts._task.attributes.channelSid,
            body: theMessage
        });
    }

    getAllMessages = () => {

        const requestUri = uhaulStore.getState().UhaulReducer.config.liveChatApiUrl + "CannedMessages";
        fetch(requestUri,
            {
                method: "GET",
                headers: GetLiveChatHeader() 
            })
            .then(response => response.json())
            .then(json => {
                if (!json.Success || !json.Data) {
                    const errorMessage = json.Errors ? json.Errors.join(" | ") : "Unknown error.";
                    ExceptionLogger(errorMessage, "CannedMessages.getAllMessages", errorMessage);
                    return;
                }
                const messages = json.Data;
                uhaulStore.dispatch(updateCannedMessages(messages));
                this.setState({ attributes: messages });
            })
            .catch(error => ExceptionLogger(error, "CannedMessages.getAllMessages", "Error with fetching Canned Messages."));
    }

    render() {
        var cannedMessages = uhaulStore.getState().UhaulReducer.cannedMessages;
        var taskContexts = uhaulStore.getState().UhaulReducer.currentTaskContext;
        var queueName = "";

        if (taskContexts !== null && !cannedMessages.length) {
            this.getAllMessages();
            return (<Box>Loading...</Box>);

        } 
        else if (!taskContexts) {
            return (<Box />);
        } 
        else {
            

            if (taskContexts._task?.attributes.type != null && taskContexts._task.attributes.type !== "supervisor-monitor") {
                queueName = taskContexts._task.attributes.type;
            }
            else if (taskContexts._task?.attributes.taskQueue != null && taskContexts._task.attributes.taskQueue !== "supervisor-monitor") {
                queueName = taskContexts._task.attributes.taskQueue;
            }
            else if (taskContexts._task?.queueName != null && taskContexts._task.queueName !== "") {
                queueName = taskContexts._task.queueName;
            }

            if(taskContexts._task?.attributes.transferQueueName != null && taskContexts._task?.attributes.transferQueueName !=="")
            {
                queueName = taskContexts._task?.attributes.transferQueueName  
            }

            // Filter for queue canned messages.
            const relevantCannedMessages = cannedMessages.filter(function (message) {
                return message.QueueId.toLowerCase() === taskContexts.queueSid.toLowerCase();
            });

            //only shows the canned messages if the task has been accepted or active.
            if (relevantCannedMessages !== null && (taskContexts._task.status !== "pending" && taskContexts._task.status !== "completed")) {
                return (
                    <Box className="loadedCannedMessages ">
                        <Text as="h2" className="Enlarged">Custom phrases {(queueName !== null && queueName !== "") ? "for " + queueName : ""}</Text>
                        <Box>
                            <UnorderedList>
                                {relevantCannedMessages.map(function (thisQuestion) {
                                    return <ListItem key={thisQuestion.Id}>
                                        <Button key={thisQuestion.Id} onClick={() => this.sendThisMessage(thisQuestion.Description)}>
                                            {thisQuestion.Title}
                                        </Button>
                                    </ListItem>;
                                }, this)}
                            </UnorderedList>
                        </Box>                        
                    </Box>
                );
            }
            else {
                return (<Box />);
            }
        }
    }
}

const mapStateToProps = (store) => {
    return {
        config: store.FlexReducer.config,
        cannedMessages: store.UhaulReducer.cannedMessages,
        taskContexts: store.UhaulReducer.currentTaskContext
    };
};

export default connect(
    mapStateToProps,
    { updateCannedMessages }
)(CannedMessages);
